<template>
  <div class="supplier-main">
    <Menus
      :menu="menu"
      icon="https://dsmapi.logistics.systems/dsm6gicons/icons8-supplier-64.png"
      @menuClicked="menuClicked"
    />
    <div class="right-container">
      <!-- <Tabulator tableID="supplierTabulator" tableTitle="Supplier" :tableData="supplierData" :multiSelect="1"
        :selectedRow.sync="selectedSupplier" /> -->
      <!-- <TableBox :tableData="supplierData" :title="Supplier" :selectedRow.sync="selectedSupplier" :loading="tableLoading" :dataType="{ 'Job DateTime': 'date' }" /> -->
      <TableBox
        :tableData="supplierData"
        title="Supplier Profile"
        :selectedRow.sync="selectedSupplier"
        :loading="tableLoading"
        :dataType="{ 'Job DateTime': 'date' }"
      />
    </div>
    <PopupEntry
      :show.sync="popupEntryShow"
      v-if="popupEntryShow"
      :title="popupEntryTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="entryRequired"
      :successMessages="entrySuccess"
      :messages="entryMessages"
      :errorMessages="entryError"
      :viewMode="viewMode"
      @requiredClicked="entryRequiredClicked"
    >
      <div class="code-section" ref="code-section">
        <Input
          placeholder="Supplier Code"
          :isRequired="true"
          :inputValue.sync="popupContent.popupData.Spp_Code"
          :isDisabled="popupContent.popupData.disabledEditing"
          ref="Spp_Code"
          :errorMessage.sync="popupContent.popupData.SppCodeError"
          validator="text,10,uppercase"
        />
        <CheckBoxV2
          title="Active"
          style="margin-left: 5px"
          :isChecked.sync="popupContent.popupData.Active"
          :isDisabled="viewMode"
        />
      </div>
      <div class="checkbox-section" ref="checkbox-section">
        <CheckBoxV2 title="Forwarding Agent" :isChecked.sync="popupContent.popupData.IsFwdAgt" :isDisabled="viewMode" />
        <CheckBoxV2 title="Shipping Agent" :isChecked.sync="popupContent.popupData.IsShipAgt" :isDisabled="viewMode" />
        <CheckBoxV2 title="Shipping Line" :isChecked.sync="popupContent.popupData.IsShipLine" :isDisabled="viewMode" />
        <CheckBoxV2 title="Airline" :isChecked.sync="popupContent.popupData.IsAirLine" :isDisabled="viewMode" />
        <CheckBoxV2
          title="Carrier Agent"
          :isChecked.sync="popupContent.popupData.IsCarrierAgt"
          :isDisabled="viewMode"
        />
        <CheckBoxV2
          title="East Malaysia Agent"
          :isChecked.sync="popupContent.popupData.IsEastMsiaAgt"
          :isDisabled="viewMode"
        />
        <CheckBoxV2
          title="Overseas Agent"
          :isChecked.sync="popupContent.popupData.IsOverseasAgt"
          :isDisabled="viewMode"
        />
        <CheckBoxV2 title="Haulier" :isChecked.sync="popupContent.popupData.IsHaulier" :isDisabled="viewMode" />
      </div>

      <Tab
        style="height: 100%"
        :tabs="tabsItems"
        :tabIndex.sync="currentTab"
        ref="tab"
        @tabClicked="tabClicked"
        :preventTabSwitch="true"
      >
        <!-- General Details -->
        <div slot="General Details">
          <div class="supplier-general-main">
            <Input
              placeholder="Name"
              :inputValue.sync="popupContent.tabsData[0].data.name"
              :isDisabled="viewMode"
              :isRequired="true"
              :errorMessage.sync="popupContent.tabsData[0].data.nameError"
              ref="Spp_Name"
              validator="text,100,uppercase"
            />
            <div class="rowBox">
              <Input
                placeholder="Short Name"
                style="padding-right: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.shortName"
                :isDisabled="viewMode"
                :isRequired="true"
                :errorMessage.sync="popupContent.tabsData[0].data.shortNameError"
                ref="Spp_sName"
                validator="text,20,uppercase"
              />
            </div>
            <InputQuery
              style="padding-left: 5px"
              placeholder="Creditor"
              :items="popupContent.tabsData[0].data.creditor"
              :selectedObject.sync="popupContent.tabsData[0].data.selectedCreditor"
              itemKey="Creditor Code"
              descKey="Creditor Name"
              :isDisabled="viewMode"
            />
            <AddressFormV2
              :address.sync="popupContent.tabsData[0].data.address"
              :addressErrors.sync="popupContent.tabsData[0].data.addressErrors"
              :viewMode="viewMode"
              ref="addressForm"
              :postcodes="postcodeData"
              :states="stateData"
              :countries="countryData"
            />
            <div class="rowBox">
              <Input
                placeholder="Phone No."
                style="padding-right: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.phone"
                :errorMessage.sync="popupContent.tabsData[0].data.phoneError"
                :isDisabled="viewMode"
                ref="Spp_Phone"
                validator="text,20"
              />
              <Input
                placeholder="Fax No."
                style="padding-left: 5px"
                :inputValue.sync="popupContent.tabsData[0].data.fax"
                :errorMessage.sync="popupContent.tabsData[0].data.faxError"
                :isDisabled="viewMode"
                ref="Spp_Fax"
                validator="text,20"
              />
            </div>
            <Input
              placeholder="E-Mail"
              :inputValue.sync="popupContent.tabsData[0].data.email"
              :errorMessage.sync="popupContent.tabsData[0].data.emailError"
              :isDisabled="viewMode"
              ref="Spp_Email"
              validator="text,40"
            />
            <Dropdown
              placeholder="Category"
              itemKey="Supplier Category"
              :selectedObject.sync="popupContent.tabsData[0].data.selectedCategory"
              :items="categoryData"
              :errorMessage.sync="popupContent.tabsData[0].data.categoryError"
              :isDisabled="viewMode"
              :allowFreeText="true"
              :search.sync="popupContent.tabsData[0].data.categoryText"
              validator="text,10"
            />
          </div>
        </div>

        <!-- Contact Details -->
        <div slot="Contact Details" style="height: 100%">
          <!-- <Contact :person.sync="popupContent.tabsData[1].data.contactPerson" :contacts.sync="popupContent.tabsData[1].data.contactItems" :postCode="popupContent.tabsData[1].data.postcodeItems" 
          :state="popupContent.tabsData[1].data.stateItems" :country="popupContent.tabsData[1].data.countryItems" :viewMode="viewMode" /> -->
          <Contact
            :person.sync="popupContent.tabsData[1].data.contactPerson"
            :contacts.sync="popupContent.tabsData[1].data.contactItems"
            :postCode="postcodeData"
            :state="stateData"
            :country="countryData"
            :viewMode="viewMode"
            :personError.sync="popupContent.tabsData[1].data.contactPersonError"
            ref="contactTab"
            :showInputs.sync="showContactDetailsInput"
          />
        </div>

        <!-- Attachments -->
        <div slot="Attachments" style="display: flex; height: 100%">
          <Attachments
            style="width: 100%"
            :attachments.sync="popupContent.tabsData[2].data.attachmentItems"
            :viewMode="viewMode"
          />
        </div>

        <!-- GST Details -->
        <div slot="GST Details">
          <GST
            :viewMode="viewMode"
            :gstData.sync="popupContent.tabsData[3].data"
            ref="gstTab"
            componentType="supplierTab"
          />

          <BoxContainer title="LHDN eInvoice Details">
            <div class="lhdn-tin">
              <button @click="validateTaxPayerTin" :disabled="validateTINIcon != ''"> Validate </button>
              <div v-if="validateTINIcon != ''" style="margin-right: -5px; margin-left: 5px">
                <Tooltip :icon="validateTINIcon" :tooltipText="validateTINMsg" />
              </div>
              <Input
                style="margin-left: 5px"
                placeholder="Tax Identification No (TIN)"
                :inputValue.sync="eInvoiceTIN"
                :isDisabled="viewMode"
                ref="eInvoiceTIN"
                validator="text,13,uppercase,alphanumeric,none"
              />
            </div>
          </BoxContainer>
        </div>

        <!-- Agent Details -->
        <div slot="Agent Details">
          <div class="agent-details-main">
            <Input
              placeholder="Agent Code"
              :isRequired="true"
              :inputValue.sync="popupContent.tabsData[4].data.agentCode"
              :errorMessage.sync="popupContent.tabsData[4].data.agentCodeError"
              ref="Ag_No"
              :isDisabled="true"
              validator="text,10,uppercase"
            />
            <div style="display: flex">
              <Input
                style="margin-right: 5px"
                placeholder="Detention Days"
                :inputValue.sync="popupContent.tabsData[4].data.detentionDays"
                :errorMessage.sync="popupContent.tabsData[4].data.detentionDaysError"
                :isDisabled="viewMode"
                :isRequired="true"
                ref="Ag_DetentionDays"
                validator="positiveInteger,3"
              />
              <Input
                style="margin-right: 5px"
                placeholder="Free Demurrage Days"
                :inputValue.sync="popupContent.tabsData[4].data.demurageDays"
                :errorMessage.sync="popupContent.tabsData[4].data.demurageDaysError"
                :isDisabled="viewMode"
                :isRequired="true"
                ref="Ag_FreeStorageDays"
                validator="positiveInteger,3"
              />
              <Input
                placeholder="Opr Code"
                :inputValue.sync="popupContent.tabsData[4].data.oprCode"
                :errorMessage.sync="popupContent.tabsData[4].data.oprCodeError"
                ref="Operator"
                :isDisabled="viewMode"
                validator="text,10"
              />
            </div>
            <InputQuery
              placeholder="Depot Bill To"
              :items="popupContent.tabsData[4].data.billToItems"
              itemKey="Customer Code"
              descKey="Customer Name"
              :selectedObject.sync="popupContent.tabsData[4].data.selectedDepotBillTo"
              :isDisabled="viewMode"
            />
            <div class="effective-date-container">
              <DateTimePicker
                placeholder="Effective Date From"
                :minDate="new Date('1990-01-01')"
                :value.sync="popupContent.tabsData[4].data.effectiveDateStart"
                :errorMessage.sync="popupContent.tabsData[4].data.effectiveDateStartError"
                :isDisabled="viewMode"
              />
              <div></div
              ><DateTimePicker
                placeholder="Until"
                :minDate="new Date('1990-01-01')"
                :value.sync="popupContent.tabsData[4].data.effectiveDateEnd"
                :errorMessage.sync="popupContent.tabsData[4].data.effectiveDateEndError"
                :isDisabled="viewMode"
              />
            </div>
            <div class="compulsory-checkbox">
              <CheckBoxV2
                title="Compulsory Cust Ref #"
                :isChecked.sync="isCompulsory"
                :isDisabled="viewMode || !popupContent.popupData.IsFwdAgt"
              />
            </div>
            <div>Link multiple container operations to shipping agent</div>
            <div class="add-del-opr-container">
              <TableBox
                :tableData="popupContent.tabsData[4].data.contOperator"
                :hideColumns="hiddenColumns"
                title="Operators"
                :selectedRow.sync="selectedContOpr"
                :loading="tableLoading"
              />
              <div v-if="!viewMode" style="margin-left: 5px">
                <Input
                  placeholder="Cont Opr"
                  :inputValue.sync="oprCode"
                  :errorMessage.sync="oprError"
                  validator="text,10,uppercase"
                />
                <button style="margin-bottom: 5px; width: 100%" @click="addOprCode">Add Operator</button>
                <button style="width: 100%" @click="delOprCode">Delete Operator</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Haulier Details -->
        <div slot="Haulier Details">
          <div class="supplier-haulier-main">
            <div :style="{ flex: 1, paddingRight: '5px', position: 'relative' }">
              <Input
                placeholder="Haulier Code"
                :isRequired="true"
                :inputValue.sync="popupContent.tabsData[5].data.haulierCode"
                :errorMessage.sync="popupContent.tabsData[5].data.haulierCodeError"
                :isDisabled="true"
                ref="Haulier_Code"
                validator="text,10,uppercase"
              />
              <Input
                placeholder="CMR Form"
                :isRequired="true"
                :inputValue.sync="popupContent.tabsData[5].data.cmrForm"
                :errorMessage.sync="popupContent.tabsData[5].data.cmrFormError"
                :isDisabled="viewMode"
                ref="CMRForm"
                validator="text,10"
              />
              <Dropdown
                placeholder="Mode"
                itemKey="Mode"
                :isRequired="true"
                :items="popupContent.tabsData[5].data.modeItems"
                :selectedObject.sync="popupContent.tabsData[5].data.selectedMode"
                :errorMessage.sync="popupContent.tabsData[5].data.modeError"
                :isDisabled="viewMode"
                ref="DepotTrMode"
              />
              <InputQuery
                placeholder="DGC Bill To"
                :items="popupContent.tabsData[5].data.billToItems"
                :selectedObject.sync="popupContent.tabsData[5].data.selectedBillTo"
                itemKey="Customer Code"
                descKey="Customer Name"
                :isDisabled="viewMode"
              />
              <button style="right: 5px; position: absolute" @click="showPM = !showPM">{{
                showPM ? 'Close'
                : viewMode ? 'View PM'
                : 'Add/View PM'
              }}</button>
              <div class="flex-area" style="margin-top: 45px">
                <Input
                  placeholder="Company Registration No"
                  :inputValue.sync="popupContent.tabsData[5].data.coRegNo"
                  :isDisabled="true"
                />
                <Input
                  style="margin-left: 5px"
                  placeholder="PKNet ID"
                  :inputValue.sync="popupContent.tabsData[5].data.pkNetID"
                  :errorMessage.sync="popupContent.tabsData[5].data.pkNetIDError"
                  :isDisabled="viewMode"
                  ref="PKNetID"
                  validator="text,10"
                />
              </div>
              <div class="flex-area">
                <DateTimePicker
                  placeholder="Date Verified"
                  :minDate="new Date('1990-01-01')"
                  :value.sync="popupContent.tabsData[5].data.dateVerified"
                  :errorMessage.sync="popupContent.tabsData[5].data.dateVerifiedError"
                  :isDisabled="viewMode"
                />
              </div>
              <Input
                placeholder="License No"
                :inputValue.sync="popupContent.tabsData[5].data.licenseNo"
                :isDisabled="true"
              />
              <Input
                placeholder="RMCD Approval No"
                :inputValue.sync="popupContent.tabsData[5].data.rmcdApprovalNo"
                :isDisabled="true"
              />
            </div>
            <div v-if="showPM" class="right-container" :style="{ flex: 1, height: showPM ? 'auto' : '0px' }">
              <TableBox
                title="Vehicle"
                class="pm-tabulator"
                :style="{ width: viewMode ? '100%' : 'calc(100% - 105px)' }"
                :tableData="popupContent.tabsData[5].data.vehicleItems"
                :hideColumns="hiddenColumns"
                :selectedRow.sync="selectedPM"
              />
              <div class="add-pm-area" v-if="!viewMode">
                <Input
                  placeholder="PM No"
                  :inputValue.sync="pmNo"
                  :isRequired="true"
                  :errorMessage.sync="pmError"
                  validator="text,25,uppercase"
                />
                <Dropdown
                  placeholder="Mvt"
                  :items="popupContent.tabsData[5].data.mvtItems"
                  :selectedObject.sync="selectedMvt"
                  itemKey="Mvt"
                />
                <button style="margin-bottom: 3px; width: 100%" @click="addPM">Add PM</button>
                <button style="width: 100%" @click="delPM">Delete PM</button>
              </div>
            </div>
          </div>
        </div>
      </Tab>
    </PopupEntry>
  </div>
</template>

<script>
import Contact from '@/components/tabComponents/ContactDetails.vue';
import Attachments from '@/components/tabComponents/Attachments.vue';
import GST from '@/components/tabComponents/GSTDetails.vue';

export default {
  components: {
    Attachments,
    GST,
    Contact,
  },
  data: function () {
    return {
      popupContent: {
        popupData: {
          IsHaulier: false,
          IsFwdAgt: false,
          IsShipAgt: false,
          IsShipLine: false,
          IsAirLine: false,
          IsCarrierAgt: false,
          IsEastMsiaAgt: false,
          IsOverseasAgt: false,
          Active: false,
          Spp_Code: '',
          SppCodeError: '',
          deletedContact: [],
          deletedAttachments: [],
          deletedContOperator: [],
          deletedVehicle: [],
          viewMode: false,
          disabledEditing: false,
          // focusElement: ''
        },
        tabsData: [
          // Tabs 0
          {
            data: {
              name: '',
              nameError: '',
              shortName: '',
              shortNameError: '',
              creditor: [],
              selectedCreditor: {},
              address: {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                addressLine4: '',
                postcode: '',
                city: '',
                state: '',
                country: '',
              },
              addressErrors: {
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                addressLine4: '',
                postcode: '',
                city: '',
                state: '',
              },
              phone: '',
              phoneError: '',
              fax: '',
              faxError: '',
              email: '',
              emailError: '',
              selectedCategory: null,
              categoryItems: [],
              categoryError: '',
              categoryText: '',
            },
          },
          // Tabs 1 - Contact
          {
            data: {
              contactPerson: '',
              contactPersonError: '',
              // refid: '',
              // name: '',
              // nameError: '',
              // position: '',
              // department: '',
              // address: {
              //   addressLine1: '',
              //   addressLine2: '',
              //   addressLine3: '',
              //   addressLine4: '',
              //   postcode: '',
              //   city: '',
              //   state: '',
              //   country: '',
              // },
              // phone: '',
              // mobile: '',
              // fax: '',
              // email: '',
              // remarks: '',
              contactItems: [],
            },
          },
          // Tabs 2
          {
            data: {
              attachmentItems: [],
              attachmentList: [],
            },
          },
          // Tabs 3
          {
            data: {
              comRegNo: '',
              comRegNoError: '',
              taxCodeItems: null,
              msicCodeItems: null,
              licenseNo: '',
              licenseNoError: '',
              rmcdApprovalNo: '',
              rmcdApprovalNoError: '',
              selectedTaxCode: null,
              selectedMSICCode: null,
              dateVerified: null,
              dateVerifiedError: '',

              //TIN number stuff at the bottom. No need to package if not needed. Otherwise messy to use.
            },
          },
          // Tabs 4
          {
            data: {
              agentCode: '',
              agentCodeError: '',
              detentionDays: '',
              detentionDaysError: '',
              demurageDays: '',
              demurageDaysError: '',
              oprCode: '',
              oprCodeError: '',
              billToItems: null,
              selectedDepotBillTo: null,
              effectiveDateStart: null,
              effectiveDateStartError: '',
              effectiveDateEnd: null,
              effectiveDateEndError: '',
              compulsoryCustRef: 0,
              contOperator: [],
            },
          },
          // Tabs 5
          {
            data: {
              haulierCode: '',
              haulierCodeError: '',
              cmrForm: '',
              cmrFormError: '',
              modeItems: [],
              selectedMode: null,
              modeError: '',
              billToItems: null,
              selectedBillTo: null,
              coRegNo: '',
              pkNetID: '',
              pkNetIDError: '',
              dateVerified: null,
              dateVerifiedError: '',
              licenseNo: '',
              rmcdApprovalNo: '',
              mvtItems: [],
              vehicleItems: [],
            },
          },
        ],
      },
      // Haulier tab properties
      showPM: { type: Boolean, default: false },
      pmNo: '',
      pmError: { type: String, default: '' },
      selectedMvt: null,
      selectedPM: [],

      // Agent tab properties
      oprCode: '',
      oprError: { type: String, default: '' },
      selectedContOpr: [],

      menu: [
        {
          title: 'New Supplier',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          enabled: true,
          visible: true,
          key: 'MnuNew',
        },
        {
          title: 'Edit Supplier',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          enabled: true,
          visible: true,
          key: 'MnuEdit',
        },
        {
          title: 'Delete Supplier',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          enabled: true,
          visible: false,
          key: 'MnuDelete',
        },
        {
          title: 'View Supplier',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          enabled: true,
          visible: true,
          key: 'MnuQuery',
        },
      ],

      selectedSupplier: [],
      createdBy: '',
      updatedBy: '',
      lastUpdate: '',
      supplierData: [],
      hiddenColumns: [
        'Attachment',
        'ID',
        '#',
        'attachmentaction',
        'Spp_Code',
        'VehicleCode',
        'VehicleCategory',
        'vehicleaction',
        'contoperatoraction',
      ],

      // Data to send to Dropdown component under 'General Details' tab
      categoryData: [],

      // Data to send to Contact component
      postcodeData: [],
      countryData: [],
      stateData: [],

      // Popup entry data
      popupEntryShow: false,
      popupEntryTitle: '',
      viewMode: false,
      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],

      currentTab: 0,

      tabsItems: [
        { title: 'General Details', disabled: false },
        { title: 'Contact Details', disabled: false },
        { title: 'Attachments', disabled: false },
        { title: 'GST Details', disabled: false },
        { title: 'Agent Details', disabled: true },
        { title: 'Haulier Details', disabled: true },
      ],

      tableLoading: false,

      /** Additional data for each tabs (Refer to tabsData array for the rest.) **/

      // Contact tab data
      oriContacts: [],
      showContactDetailsInput: false,

      // Attachment tab data
      oriAttachmentFiles: [],

      errorMapping: [
        { key: 'Spp_Code', tab: -1 },
        { key: 'Spp_Name', tab: 0 },
        { key: 'Spp_sName', tab: 0 },
        { key: 'Spp_RegNo', tab: 0 },
        { key: 'Spp_Addr1', tab: 0 },
        { key: 'Spp_Addr2', tab: 0 },
        { key: 'Spp_Addr3', tab: 0 },
        { key: 'Spp_Addr4', tab: 0 },
        { key: 'Spp_City', tab: 0 },
        { key: 'Spp_Phone', tab: 0 },
        { key: 'Spp_Fax', tab: 0 },
        { key: 'Spp_Email', tab: 0 },
        { key: 'Spp_Contact', tab: 1 },
        { key: 'GST2LicenseNo', tab: 3 },
        { key: 'GST2RMCDApprovalNo', tab: 3 },
        { key: 'Ag_No', tab: 4 },
        { key: 'Ag_DetentionDays', tab: 4 },
        { key: 'Ag_FreeStorageDays', tab: 4 },
        { key: 'Operator', tab: 4 },
        { key: 'Haulier_Code', tab: 5 },
        { key: 'CMRForm', tab: 5 },
        { key: 'DepotTrMode', tab: 5 },
        { key: 'PKNetID', tab: 5 },
      ],

      // GST Tab, LHDN eInvoice Details section (TIN)
      validateTINIcon: '',
      validateTINMsg: 'Not Validated',
      eInvoiceTIN: '',
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=Master&page=Supplier`);
      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      this.$fullscreenLoading('');
    },
    menuClicked: function (e) {
      switch (e.title) {
        case 'New Supplier':
          this.newSupplier();
          this.viewMode = false;
          break;
        case 'Edit Supplier':
          this.viewEditClicked('edit');
          this.viewMode = false;
          break;
        case 'Delete Supplier':
          this.viewEditClicked('delete');
          break;
        case 'View Supplier':
          this.viewEditClicked('view');
          this.viewMode = true;
          break;
      }
    },
    newSupplier: function () {
      this.clearMessages();
      this.clearData();

      this.popupEntryTitle = 'New Supplier';
      this.popupEntryShow = true;
      this.popupContent.popupData.disabledEditing = false;
    },
    viewEditClicked: async function (status) {
      if (this.selectedSupplier.length > 0) {
        this.clearMessages();
        this.clearData();

        if (status == 'delete') {
          const delSupp = await this.$showAlert(
            'warning',
            'Delete Supplier',
            `Are you sure you want to delete Supplier ${this.selectedSupplier[0]['Supplier Name']}?`,
            [{ text: 'Delete' }, { text: 'Cancel' }],
          );
          if (delSupp === 'Cancel') {
            return;
          }
        } else {
          this.popupEntryShow = true;
        }

        this.popupContent.popupData.disabledEditing = true;

        this.$fullscreenLoading('Getting Supplier Details');
        const details = await this.$apiCallV2('/Master/GetDetailsMaster', {
          masterfile: 'supplier',
          recordid: this.selectedSupplier[0]['Supplier Code'].trim(),
        });

        this.$fullscreenLoading('Getting Category');
        const categories = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'supplier_category' });
        categories.forEach((c) => {
          c['Supplier Category'] = c['Supplier Category'].trim();
        });
        this.popupContent.tabsData[0].data.categoryItems = categories;
        this.categoryData = categories;

        this.$fullscreenLoading('Getting Supplier Attachments');
        const attachments = await this.$apiCallV2(
          `/Supplier/GetMasterFileAttachments?refno=${this.selectedSupplier[0]['Supplier Code'].trim()}`,
        );
        this.$fullscreenLoading();
        //

        // this.popupEntryTitle = 'Edit Customer';
        this.populateCheckbox(details.Supplier2);
        this.populateSupplier(details.Supplier2);
        this.populateContact(details.Supplier2.Contact, details.Supplier2['Spp_Contact']);
        this.populateAttachments(attachments);
        this.populateGST(details.Supplier2.GST);
        this.populateAgent(details.Supplier2.Agent, details.Supplier2);
        this.populateHaulier(details.Supplier2.Haulier, details.Supplier2.GST, details.Supplier2);

        this.createdBy = `${details.Supplier2['UserCreated'] || ''} ${details.Supplier2['TimeCreated'] ? new Date(details.Supplier2['TimeCreated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
        this.updatedBy = `${details.Supplier2['UserID'].trim()} ${new Date(details.Supplier2['DateUpdate']).formatString('dd/MM/yyyy HH:mm')}`;
        this.lastUpdate = details.Supplier2['DateUpdate'];

        this.popupEntryTitle = status == 'edit' ? 'Edit Supplier' : 'View Supplier (ReadOnly)';

        if (status == 'delete') {
          this.saveClicked(true);
        } else {
          this.showPopup = true;
        }
      } else {
        this.$showAlert('error', 'No Supplier Selected', `Please select a record to ${status}`);
      }
    },

    saveClicked: async function (isDelete) {
      this.clearMessages();

      if (this.showContactDetailsInput) {
        const discardChanges = await this.promptDiscardContactDetailsChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showContactDetailsInput = false;
      }

      const checkErrors = this.checkFields();
      if (checkErrors) return;

      // Setting up contacts to delete
      const contactIDs = this.popupContent.tabsData[1].data.contactItems.map((e) => {
        return e['ID'];
      });
      this.popupContent.popupData.deletedContact = this.oriContacts.filter((e) => {
        return !contactIDs.includes(e.ID);
      });

      const contactToPost = this.popupContent.tabsData[1].data.contactItems.filter((c) => {
        return c.contactaction;
      });
      this.popupContent.popupData.deletedContact.forEach((d) => {
        d.contactaction = 'D';
        contactToPost.push(d);
      });

      // Setting up attachments to delete
      const attachmentIDs = this.popupContent.tabsData[2].data.attachmentItems.map((e) => {
        return e['ID'];
      });
      this.popupContent.popupData.deletedAttachments = this.oriAttachmentFiles.filter((e) => {
        return !attachmentIDs.includes(e.ID);
      });

      const attachmentToPost = this.popupContent.tabsData[2].data.attachmentItems.filter((a) => {
        return a.attachmentaction;
      });
      this.popupContent.popupData.deletedAttachments.forEach((d) => {
        d.attachmentaction = 'D';
        attachmentToPost.push(d);
      });

      // // Check attachmentsToPost files to ensure they are not empty
      const emptyAttachmentExists = attachmentToPost.some((attachment) => {
        return !attachment['Attachment'];
      });
      if (emptyAttachmentExists == true) {
        this.entryError.push('Some files in your attachments have no data!');
        return;
      }

      const contOperatorToPost = this.popupContent.tabsData[4].data.contOperator.filter((c) => {
        return c.contoperatoraction;
      });
      this.popupContent.popupData.deletedContOperator.forEach((d) => {
        d.contoperatoraction = 'D';
        contOperatorToPost.push(d);
      });

      const vehicleToPost = this.popupContent.tabsData[5].data.vehicleItems.filter((v) => {
        return v.vehicleaction;
      });
      this.popupContent.popupData.deletedVehicle.forEach((d) => {
        d.vehicleaction = 'D';
        vehicleToPost.push(d);
      });

      const toPost = {
        action:
          this.popupEntryTitle == 'New Supplier' ? 'N'
          : isDelete ? 'D'
          : 'E',
        Active: this.popupContent.popupData.Active ? '1' : '0',
        Spp_Code: this.popupContent.popupData.Spp_Code.trim(),
        Spp_Name: this.popupContent.tabsData[0].data.name,
        Spp_sName: this.popupContent.tabsData[0].data.shortName.trim(),
        Spp_Addr1: this.popupContent.tabsData[0].data.address.addressLine1,
        Spp_Addr2: this.popupContent.tabsData[0].data.address.addressLine2,
        Spp_Addr3: this.popupContent.tabsData[0].data.address.addressLine3,
        Spp_Addr4: this.popupContent.tabsData[0].data.address.addressLine4,
        Spp_Contact: this.popupContent.tabsData[1].data.contactPerson,
        Spp_TelNo: this.popupContent.tabsData[0].data.phone,
        Spp_Fax: this.popupContent.tabsData[0].data.fax,
        Spp_Email: this.popupContent.tabsData[0].data.email,
        DateUpdate: new Date().formatString('yyyy-MM-dd HH:mm:ss'),
        Spp_PostCode: this.popupContent.tabsData[0].data.address.postcode,
        Spp_Country: this.popupContent.tabsData[0].data.address.country,
        Spp_City: this.popupContent.tabsData[0].data.address.city,
        Spp_State: this.popupContent.tabsData[0].data.address.state,
        Spp_Category: this.popupContent.tabsData[0].data.categoryText.trim() || '',
        CreditorCode:
          this.popupContent.tabsData[0].data.selectedCreditor ?
            this.popupContent.tabsData[0].data.selectedCreditor['Creditor Code']
          : '',
        IsHaulier: this.popupContent.popupData.IsHaulier ? 1 : 0,
        IsFwdAgt: this.popupContent.popupData.IsFwdAgt ? 1 : 0,
        IsShipAgt: this.popupContent.popupData.IsShipAgt ? 1 : 0,
        IsShipLine: this.popupContent.popupData.IsShipLine ? 1 : 0,
        IsAirLine: this.popupContent.popupData.IsAirLine ? 1 : 0,
        IsCarrierAgt: this.popupContent.popupData.IsCarrierAgt ? 1 : 0,
        IsEastMsiaAgt: this.popupContent.popupData.IsEastMsiaAgt ? 1 : 0,
        IsOverseasAgt: this.popupContent.popupData.IsOverseasAgt ? 1 : 0,
        Ag_No: this.popupContent.tabsData[4].data.agentCode,
        Haulier_Code: this.popupContent.tabsData[5].data.haulierCode,
        LastUpdate: this.lastUpdate ? new Date(this.lastUpdate).formatString('yyyy-MM-dd HH:mm:ss') : '',
        Contact: contactToPost,
        GST: {
          GST2CoRegNo: this.popupContent.tabsData[3].data.comRegNo,
          GST2LicenseNo: this.popupContent.tabsData[3].data.licenseNo,
          GST2RMCDApprovalNo: this.popupContent.tabsData[3].data.rmcdApprovalNo,
          GST2TaxCode:
            this.popupContent.tabsData[3].data.selectedTaxCode ?
              this.popupContent.tabsData[3].data.selectedTaxCode['Tax Code']
            : '',
          GST2MSICCode:
            this.popupContent.tabsData[3].data.selectedMSICCode ?
              this.popupContent.tabsData[3].data.selectedMSICCode['MSIC Code']
            : '',
          GST2DateStatusVerified:
            this.popupContent.tabsData[3].data.dateVerified ?
              `${new Date(this.popupContent.tabsData[3].data.dateVerified).formatString('yyyy-MM-dd HH:mm')}:00`
            : '',
          TIN: this.eInvoiceTIN,
        },
        Attachment: attachmentToPost,
      };

      if (!isDelete) {
        if (
          this.popupContent.popupData.IsFwdAgt ||
          this.popupContent.popupData.IsShipAgt ||
          this.popupContent.popupData.IsShipLine ||
          this.popupContent.popupData.IsAirLine ||
          this.popupContent.popupData.IsCarrierAgt ||
          this.popupContent.popupData.IsEastMsiaAgt ||
          this.popupContent.popupData.IsOverseasAgt
        ) {
          toPost.Agent = {
            Ag_DetentionDays: this.popupContent.tabsData[4].data.detentionDays,
            Ag_FreeStorageDays: this.popupContent.tabsData[4].data.demurageDays,
            Ag_ProfitShare: '',
            DepotBillCu_No:
              this.popupContent.tabsData[4].data.selectedDepotBillTo ?
                this.popupContent.tabsData[4].data.selectedDepotBillTo['Customer Code']
              : '',
            Operator: this.popupContent.tabsData[4].data.oprCode,
            Ag_StartDate:
              this.popupContent.tabsData[4].data.effectiveDateStart ?
                new Date(this.popupContent.tabsData[4].data.effectiveDateStart).formatString('yyyy-MM-dd HH:mm:ss')
              : '',
            Ag_ExpDate:
              this.popupContent.tabsData[4].data.effectiveDateEnd ?
                new Date(this.popupContent.tabsData[4].data.effectiveDateEnd).formatString('yyyy-MM-dd HH:mm:ss')
              : '',
            HMS_CompulsoryCustRefNo: this.popupContent.tabsData[4].data.compulsoryCustRef == true ? 1 : 0,
            ContOp: contOperatorToPost,
          };
        }

        if (this.popupContent.popupData.IsHaulier) {
          toPost.Haulier = {
            CMRForm: this.popupContent.tabsData[5].data.cmrForm,
            DepotTrMode:
              this.popupContent.tabsData[5].data.selectedMode ?
                this.popupContent.tabsData[5].data.selectedMode['Mode']
              : '',
            DepotDGCBillTo:
              this.popupContent.tabsData[5].data.selectedBillTo ?
                this.popupContent.tabsData[5].data.selectedBillTo['Customer Code']
              : '',
            PKNetID: this.popupContent.tabsData[5].data.pkNetID,
            Vehicle: vehicleToPost,
          };
        }
      }

      this.$fullscreenLoading('Saving Supplier');
      const save = await this.$apiCallV2('/Supplier/SaveSupplier', toPost);
      this.$fullscreenLoading();

      if (isDelete && save[0].Results == 0) {
        this.$showAlert(
          'success',
          'Deleted',
          `Successfully deleted supplier ${this.popupContent.tabsData[0].data.name}`,
        );
        // Refresh supplier data
        const suppliers = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'supplier' });
        this.supplierData = [];
        this.$nextTick(() => {
          this.supplierData = suppliers;
          this.selectedSupplier = [];
        });
      }

      if (!isDelete) {
        if (!save) {
          this.entryError.push('Backend Error. Please ensure your inputs are in the correct format.');
        }
        // else if (save.status == 1) {
        //   this.entryRequired = save.error;
        // }
        else if (save[0].Results == 1) {
          this.entryError.push(save[0].ErrMsg);
        } else if (save[0].Results == 0) {
          this.entrySuccess.push('Successfully saved Supplier!');
          this.viewMode = true;
          this.popupContent.popupData.disabledEditing = true;
          // Refresh supplier data
          const suppliers = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'supplier' });
          this.supplierData = [];
          this.$nextTick(() => {
            this.supplierData = suppliers;
            this.selectedSupplier = [];
          });
        }
      }
    },
    clearData: function () {
      this.createdBy = '';
      this.updatedBy = '';
      this.lastUpdate = '';

      this.currentTab = 0;

      this.popupContent.popupData = {
        IsHaulier: false,
        IsFwdAgt: false,
        IsShipAgt: false,
        IsShipLine: false,
        IsAirLine: false,
        IsCarrierAgt: false,
        IsEastMsiaAgt: false,
        IsOverseasAgt: false,
        Active: false,
        Spp_Code: '',
        disabledSuppCode: false,
        deletedContact: [],
        deletedAttachments: [],
        deletedContOperator: [],
        deletedVehicle: [],
        viewMode: false,
        // focusElement: ''
      };

      // Clearing Tab 1
      this.popupContent.tabsData[0].data.name = '';
      this.popupContent.tabsData[0].data.shortName = '';
      this.popupContent.tabsData[0].data.selectedCreditor = null;
      this.popupContent.tabsData[0].data.address.addressLine1 = '';
      this.popupContent.tabsData[0].data.address.addressLine2 = '';
      this.popupContent.tabsData[0].data.address.addressLine3 = '';
      this.popupContent.tabsData[0].data.address.addressLine4 = '';
      this.popupContent.tabsData[0].data.address.postcode = '';
      this.popupContent.tabsData[0].data.address.city = '';
      this.popupContent.tabsData[0].data.address.state = '';
      this.popupContent.tabsData[0].data.address.country = '';
      this.popupContent.tabsData[0].data.phone = '';
      this.popupContent.tabsData[0].data.fax = '';
      this.popupContent.tabsData[0].data.email = '';
      this.popupContent.tabsData[0].data.selectedCategory = null;
      this.popupContent.tabsData[0].data.categoryText = '';
      // Clearing Tab 1

      // Clearing Tab 2
      this.popupContent.tabsData[1].data.contactPerson = '';
      // this.popupContent.tabsData[1].data.refid = '';
      // this.popupContent.tabsData[1].data.name = '';
      // this.popupContent.tabsData[1].data.position = '';
      // this.popupContent.tabsData[1].data.department = '';

      // //
      // this.popupContent.tabsData[1].data.address.addressLine1 = '';
      // this.popupContent.tabsData[1].data.address.addressLine2 = '';
      // this.popupContent.tabsData[1].data.address.addressLine3 = '';
      // this.popupContent.tabsData[1].data.address.addressLine4 = '';
      // this.popupContent.tabsData[1].data.address.postcode = '';
      // this.popupContent.tabsData[1].data.address.city = '';
      // this.popupContent.tabsData[1].data.address.state = '';
      // this.popupContent.tabsData[1].data.address.country = '';

      // this.popupContent.tabsData[1].data.phone = '';
      // this.popupContent.tabsData[1].data.mobile = '';
      // this.popupContent.tabsData[1].data.fax = '';
      // this.popupContent.tabsData[1].data.email = '';
      // this.popupContent.tabsData[1].data.remarks = '';
      this.popupContent.tabsData[1].data.contactItems = [];
      // Clearing Tab 2

      // Clearing Tab 3
      this.popupContent.tabsData[2].data.attachmentItems = [];
      this.popupContent.tabsData[2].data.attachmentList = [];
      this.eInvoiceTIN = '';
      // Clearing Tab 3

      // Clearing Tab 4
      this.popupContent.tabsData[3].data.comRegNo = '';
      this.popupContent.tabsData[3].data.licenseNo = '';
      this.popupContent.tabsData[3].data.rmcdApprovalNo = '';
      this.popupContent.tabsData[3].data.selectedTaxCode = null;
      this.popupContent.tabsData[3].data.selectedMSICCode = null;
      this.popupContent.tabsData[3].data.dateVerified = null;
      // Clearing Tab 4

      // Clearing Tab 5
      this.popupContent.tabsData[4].data.agentCode = '';
      this.popupContent.tabsData[4].data.detentionDays = '';
      this.popupContent.tabsData[4].data.demurageDays = '';
      this.popupContent.tabsData[4].data.oprCode = '';
      this.popupContent.tabsData[4].data.selectedDepotBillTo = null;
      this.popupContent.tabsData[4].data.effectiveDateStart = null;
      this.popupContent.tabsData[4].data.effectiveDateEnd = null;
      this.popupContent.tabsData[4].data.compulsoryCustRef = 0;
      this.popupContent.tabsData[4].data.contOperator = [];
      // Clearing Tab 5

      // Clearing Tab 6
      this.popupContent.tabsData[5].data.haulierCode = '';
      this.popupContent.tabsData[5].data.cmrForm = '';
      this.popupContent.tabsData[5].data.selectedMode = null;
      this.popupContent.tabsData[5].data.selectedBillTo = null;
      this.popupContent.tabsData[5].data.coRegNo = '';
      this.popupContent.tabsData[5].data.pkNetID = '';
      this.popupContent.tabsData[5].data.dateVerifiedError = '';
      this.popupContent.tabsData[5].data.dateVerified = null;
      this.popupContent.tabsData[5].data.licenseNo = '';
      this.popupContent.tabsData[5].data.rmcdApprovalNo = '';
      this.popupContent.tabsData[5].data.vehicleItems = [];
      this.showPM = false;

      // Clearing Tab 6

      this.clearMessages();
    },
    clearMessages: function () {
      this.entryMessages = [];
      this.entryError = [];
      this.entryRequired = [];
      this.entrySuccess = [];

      // clearing error messages in input field
      this.popupContent.popupData.SppCodeError = '';
      this.popupContent.tabsData[0].data.nameError = '';
      this.popupContent.tabsData[0].data.shortNameError = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine1 = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine2 = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine3 = '';
      this.popupContent.tabsData[0].data.addressErrors.addressLine4 = '';
      this.popupContent.tabsData[0].data.addressErrors.city = '';
      this.popupContent.tabsData[0].data.phoneError = '';
      this.popupContent.tabsData[0].data.faxError = '';
      this.popupContent.tabsData[0].data.emailError = '';
      this.popupContent.tabsData[0].data.categoryError = '';
      this.popupContent.tabsData[1].data.contactPersonError = '';
      this.popupContent.tabsData[3].data.comRegNoError = '';
      this.popupContent.tabsData[3].data.licenseNoError = '';
      this.popupContent.tabsData[3].data.rmcdApprovalNoError = '';
      this.popupContent.tabsData[4].data.agentCodeError = '';
      this.popupContent.tabsData[4].data.detentionDaysError = '';
      this.popupContent.tabsData[4].data.demurageDaysError = '';
      this.popupContent.tabsData[4].data.oprCodeError = '';
      this.popupContent.tabsData[4].data.effectiveDateStartError = '';
      this.popupContent.tabsData[4].data.effectiveDateEndError = '';
      this.oprError = '';
      this.popupContent.tabsData[5].data.haulierCodeError = '';
      this.popupContent.tabsData[5].data.cmrFormError = '';
      this.popupContent.tabsData[5].data.modeError = '';
      this.popupContent.tabsData[5].data.pkNetIDError = '';
      this.pmError = '';

      //GST Tab, LHDN eInvoice Details section (TIN)
      this.validateTINIcon = '';
      this.validateTINMsg = 'Not Validated';
    },

    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },
    // Populating Tabs
    populateCheckbox: function (item) {
      this.popupContent.popupData.IsFwdAgt = item['IsFwdAgt'] == '1';
      this.popupContent.popupData.IsShipAgt = item['IsShipAgt'] == '1';
      this.popupContent.popupData.IsShipLine = item['IsShipLine'] == '1';
      this.popupContent.popupData.IsAirLine = item['IsAirLine'] == '1';
      this.popupContent.popupData.IsCarrierAgt = item['IsCarrierAgt'] == '1';
      this.popupContent.popupData.IsEastMsiaAgt = item['IsEastMsiaAgt'] == '1';
      this.popupContent.popupData.IsOverseasAgt = item['IsOverseasAgt'] == '1';
      this.popupContent.popupData.IsHaulier = item['IsHaulier'] == '1';
    },
    populateSupplier: function (supplier) {
      this.popupContent.popupData.Spp_Code = supplier['Spp_Code'] ? supplier['Spp_Code'].trim() : '';
      this.popupContent.popupData.Active = supplier['Active'] == '1';

      this.popupContent.tabsData[0].data.name = supplier['Spp_Name'] ? supplier['Spp_Name'].trim() : '';
      this.popupContent.tabsData[0].data.shortName = supplier['Spp_sName'] ? supplier['Spp_sName'].trim() : '';

      this.popupContent.tabsData[0].data.address.addressLine1 =
        supplier['Spp_Addr1'] ? supplier['Spp_Addr1'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine2 =
        supplier['Spp_Addr2'] ? supplier['Spp_Addr2'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine3 =
        supplier['Spp_Addr3'] ? supplier['Spp_Addr3'].trim() : '';
      this.popupContent.tabsData[0].data.address.addressLine4 =
        supplier['Spp_Addr4'] ? supplier['Spp_Addr4'].trim() : '';

      this.popupContent.tabsData[0].data.address.postcode =
        supplier['Spp_PostCode'] ? supplier['Spp_PostCode'].trim() : '';
      this.popupContent.tabsData[0].data.address.state = supplier['Spp_State'] ? supplier['Spp_State'].trim() : '';
      this.popupContent.tabsData[0].data.address.city = supplier['Spp_City'] ? supplier['Spp_City'].trim() : '';
      this.popupContent.tabsData[0].data.address.country =
        supplier['Spp_Country'] ? supplier['Spp_Country'].trim() : '';

      // Populate object for dropdown selection
      this.popupContent.tabsData[0].data.phone = supplier['Spp_TelNo'] ? supplier['Spp_TelNo'].trim() : '';
      this.popupContent.tabsData[0].data.fax = supplier['Spp_Fax'] ? supplier['Spp_Fax'].trim() : '';
      this.popupContent.tabsData[0].data.email = supplier['Spp_Email'] ? supplier['Spp_Email'].trim() : '';

      const creditor = supplier['CreditorCode'] ? supplier['CreditorCode'].trim() : '';
      this.popupContent.tabsData[0].data.selectedCreditor = this.populateObject(
        this.popupContent.tabsData[0].data.creditor,
        'Creditor Code',
        creditor,
      );

      const category = supplier['Spp_Category'] ? supplier['Spp_Category'].trim() : '';
      this.popupContent.tabsData[0].data.selectedCategory = this.populateObject(
        this.popupContent.tabsData[0].data.categoryItems,
        'Supplier Category',
        category,
      );
    },
    populateContact: function (contact, contactPerson) {
      if (!contact) {
        return;
      }

      if (!Array.isArray(contact)) {
        contact = [contact];
      }
      this.popupContent.tabsData[1].data.contactPerson = contactPerson ? contactPerson.trim() : '';
      contact.forEach((c) => {
        const contactEntry = {
          contactaction: '',
          ID: c.ID ? c.ID.trim() : '',
          ContactPerson: c.ContactPerson ? c.ContactPerson.trim() : '',
          TitlePosition: c.TitlePosition ? c.TitlePosition.trim() : '',
          Department: c.Department ? c.Department.trim() : '',
          Addr1: c.Addr1 ? c.Addr1.trim() : '',
          Addr2: c.Addr2 ? c.Addr2.trim() : '',
          Addr3: c.Addr3 ? c.Addr3.trim() : '',
          Addr4: c.Addr4 ? c.Addr4.trim() : '',
          PostCode: c.PostCode ? c.PostCode.trim() : '',
          City: c.City ? c.City.trim() : '',
          State: c.State ? c.State.trim() : '',
          Country: c.Country ? c.Country.trim() : '',
          TelNo: c.TelNo ? c.TelNo.trim() : '',
          MobileNo: c.MobileNo ? c.MobileNo.trim() : '',
          FaxNo: c.FaxNo ? c.FaxNo.trim() : '',
          Email: c.Email ? c.Email.trim() : '',
          Remarks: c.Remarks ? c.Remarks.trim() : '',
        };
        this.popupContent.tabsData[1].data.contactItems.push(contactEntry);
        this.oriContacts.push(contactEntry);
      });
    },
    populateAttachments: function (attachments) {
      attachments.forEach((a) => {
        const attachmentEntry = {
          attachmentaction: '',
          ID: a['ID'],
          FileName: a['File Name'],
          Remarks: a['Remarks'],
          Attachment: a['Attachment'],
        };
        this.popupContent.tabsData[2].data.attachmentItems.push(attachmentEntry);
        this.oriAttachmentFiles.push(attachmentEntry);
      });
    },
    populateGST: function (gst) {
      if (!gst) {
        return;
      }

      this.popupContent.tabsData[3].data.comRegNo = gst['GST2CoRegNo'];
      this.popupContent.tabsData[3].data.dateVerified =
        gst['GST2DateStatusVerified'] ? new Date(gst['GST2DateStatusVerified']) : null;
      this.popupContent.tabsData[3].data.licenseNo = gst['GST2LicenseNo'];
      this.popupContent.tabsData[3].data.rmcdApprovalNo = gst['GST2RMCDApprovalNo'];

      if (gst['GST2TaxCode']) {
        const selectedTax = this.popupContent.tabsData[3].data.taxCodeItems.filter((t) => {
          return t['Tax Code'].trim() == gst['GST2TaxCode'].trim();
        });
        this.popupContent.tabsData[3].data.selectedTaxCode = selectedTax[0];
      }

      if (gst['GST2MSICCode']) {
        const selectedMSICCode = this.popupContent.tabsData[3].data.msicCodeItems.filter((t) => {
          return t['MSIC Code'].trim() == gst['GST2MSICCode'].trim();
        });
        this.popupContent.tabsData[3].data.selectedMSICCode = selectedMSICCode[0];
      }

      this.eInvoiceTIN = gst['TIN'];
    },
    populateAgent: function (agent, code) {
      if (!agent) {
        return;
      }

      if (code['Ag_No']) {
        this.popupContent.tabsData[4].data.agentCode = code['Ag_No'].trim();
      }

      this.popupContent.tabsData[4].data.detentionDays = agent['Ag_DetentionDays'];
      this.popupContent.tabsData[4].data.demurageDays = agent['Ag_FreeStorageDays'];
      this.popupContent.tabsData[4].data.oprCode = agent['Operator'];

      if (agent['DepotBillCu_No']) {
        const selectedCust = this.popupContent.tabsData[4].data.billToItems.filter((d) => {
          return d['Customer Code'].trim() == agent['DepotBillCu_No'].trim();
        });
        this.popupContent.tabsData[4].data.selectedDepotBillTo = selectedCust[0];
      }

      this.popupContent.tabsData[4].data.effectiveDateStart =
        agent['Ag_StartDate'] ? new Date(agent['Ag_StartDate']) : null;
      this.popupContent.tabsData[4].data.effectiveDateEnd = agent['Ag_ExpDate'] ? new Date(agent['Ag_ExpDate']) : null;
      this.popupContent.tabsData[4].data.compulsoryCustRef = agent['HMS_CompulsoryCustRefNo'];
      // Added check here if there is ContOperator
      if (agent['ContOperator']) {
        agent['ContOperator'].forEach((c) => {
          this.popupContent.tabsData[4].data.contOperator.push({
            contoperatoraction: '',
            ContOperator: c['ContOpr'] ? c['ContOpr'].trim() : '',
          });
        });
      }
    },
    populateHaulier: function (haulier, gst, code) {
      if (haulier) {
        this.popupContent.tabsData[5].data.cmrForm = haulier['CMRForm'] ? haulier['CMRForm'].trim() : '';

        if (haulier['DepotTrMode']) {
          const mode = this.popupContent.tabsData[5].data.modeItems.filter((b) => {
            return b['Mode'].trim() == haulier['DepotTrMode'].trim();
          });
          this.popupContent.tabsData[5].data.selectedMode = mode[0];
        }

        if (haulier['DepotDGCBillTo']) {
          const billTo = this.popupContent.tabsData[5].data.billToItems.filter((b) => {
            return b['Customer Code'].trim() == haulier['DepotDGCBillTo'].trim();
          });
          this.popupContent.tabsData[5].data.selectedBillTo = billTo[0];
        }

        this.popupContent.tabsData[5].data.pkNetID = haulier['PKNetID'] ? haulier['PKNetID'].trim() : '';

        if (haulier['Vehicle']) {
          haulier['Vehicle'].forEach((v) => {
            this.popupContent.tabsData[5].data.vehicleItems.push({
              vehicleaction: '',
              Lorry_No: v['Lorry_No'] ? v['Lorry_No'].trim() : '',
              VehicleCode: v['VehicleCode'] ? v['VehicleCode'].trim() : '',
              Type: v['Type'] ? v['Type'].trim() : '',
            });
          });
        }
      }

      if (gst) {
        this.popupContent.tabsData[5].data.coRegNo = gst['GST2CoRegNo'] ? gst['GST2CoRegNo'].trim() : '';
        this.popupContent.tabsData[5].data.dateVerified =
          gst['GST2DateStatusVerified'] ? new Date(gst['GST2DateStatusVerified']) : '';
        this.popupContent.tabsData[5].data.licenseNo = gst['GST2LicenseNo'] ? gst['GST2LicenseNo'].trim() : '';
        this.popupContent.tabsData[5].data.rmcdApprovalNo =
          gst['GST2RMCDApprovalNo'] ? gst['GST2RMCDApprovalNo'].trim() : '';
      }

      if (code) {
        this.popupContent.tabsData[5].data.haulierCode = code['Haulier_Code'] ? code['Haulier_Code'].trim() : '';
      }
    },

    entryRequiredClicked: function (item) {
      const errorTab = this.errorMapping.find((e) => e['key'] == item);

      if (errorTab && errorTab['tab'] >= 0) {
        this.currentTab = errorTab['tab'];
      }

      this.$nextTick(() => {
        switch (errorTab['key']) {
          case 'Spp_Addr1':
            this.$refs['addressForm'].setFocus('address1');
            break;

          case 'Spp_Addr2':
            this.$refs['addressForm'].setFocus('address2');
            break;

          case 'Spp_Addr3':
            this.$refs['addressForm'].setFocus('address3');
            break;

          case 'Spp_Addr4':
            this.$refs['addressForm'].setFocus('address4');
            break;

          case 'Spp_City':
            this.$refs['addressForm'].setFocus('city');
            break;

          case 'Spp_Contact':
            this.$refs['contactTab'].focusContactPersonInput();
            break;

          case 'GST2LicenseNo':
            this.$refs['gstTab'].focusGSTInput('licenseno');
            break;

          case 'GST2RMCDApprovalNo':
            this.$refs['gstTab'].focusGSTInput('rmcdapprovalno');
            break;

          default:
            this.$refs[item].setFocus();
            break;
        }
      });
    },

    // Agent Details tab methods
    addOprCode: function () {
      if (this.oprCode.trim() != '') {
        if (this.oprCode.length > 10) {
          this.oprError = 'Cont Operator cannot exceed 10 characters!';
          return;
        }
        this.$bus.$emit('oprCodeAdded', {
          ContOperator: this.oprCode,
          Spp_Code: this.popupContent.popupData.Spp_Code,
        });
        this.oprCode = '';
      } else {
        this.oprError = 'Cont Operator is required!';
      }
    },
    delOprCode: async function () {
      if (this.selectedContOpr.length == 0) {
        this.$showAlert('error', 'No Cont Operator Selected', 'Please select a cont operator to delete');
      } else {
        const deleteContOpr = await this.$showAlert(
          'warning',
          'Cont Operator Delete',
          `Are you sure you want to delete ${this.selectedContOpr.length} Cont Operator?`,
          [{ text: 'Delete' }, { text: 'Cancel' }],
        );

        if (deleteContOpr === 'Delete') {
          this.$bus.$emit('oprCodeDeleted', this.selectedContOpr);
          this.selectedContOpr = [];
        }
      }
    },
    oprCodeAdded: async function (opr) {
      // find duplicate Opr Code
      const duplicateOprCodeIndex = this.popupContent.tabsData[4].data.contOperator.findIndex(
        (i) => i.ContOperator.trim().toUpperCase() === opr.ContOperator.trim(),
      );
      if (duplicateOprCodeIndex !== -1) {
        await this.$showAlert(
          'warning',
          'Duplicate Container Operator',
          `The Container Operator ${opr.ContOperator.trim()} already exists. \nPlease enter a new Container Operator.`,
          [{ text: 'Ok', color: 'green', textColor: 'white' }],
        );
        return;
      }
      // Check if the operator code was deleted
      // If found in the deletedContOperator array, remove it (since the user added it back)
      const deletedCheck = this.popupContent.popupData.deletedContOperator.findIndex(
        (i) => i.ContOperator.trim().toUpperCase() === opr.ContOperator.trim(),
      );
      if (deletedCheck !== -1) {
        this.popupContent.popupData.deletedContOperator.splice(deletedCheck, 1);
      }

      const temp = this.popupContent.tabsData[4].data.contOperator;
      this.popupContent.tabsData[4].data.contOperator = [];
      temp.push({
        contoperatoraction: 'N',
        ContOperator: opr['ContOperator'],
      });

      this.$nextTick(() => {
        this.popupContent.tabsData[4].data.contOperator = temp;
      });
    },
    oprCodeDeleted: function (oprDel) {
      oprDel.forEach((o) => {
        const temp = this.popupContent.tabsData[4].data.contOperator;
        const delIndex = this.popupContent.tabsData[4].data.contOperator.findIndex(
          (i) => i.ContOperator === o.ContOperator,
        );
        this.popupContent.tabsData[4].data.contOperator = [];
        temp.splice(delIndex, 1);
        this.$nextTick(() => {
          this.popupContent.tabsData[4].data.contOperator = temp;
        });
        if (!o.contoperatoraction) {
          this.popupContent.popupData.deletedContOperator.push(o);
        }
      });
    },

    // Haulier Details tab methods
    addPM: function () {
      if (this.pmNo.trim()) {
        if (this.pmNo.length > 10) {
          this.pmError = 'PM No cannot exceed 10 characters!';
          return;
        }
        this.$bus.$emit('pmAdded', { Lorry_No: this.pmNo, Type: this.selectedMvt ? this.selectedMvt['Mvt'] : '' });
      } else {
        this.pmError = 'PM No is required!';
      }
    },
    delPM: async function () {
      if (this.selectedPM.length == 0) {
        this.$showAlert('error', 'No PM Selected', 'Please select PM on the list to delete');
      } else {
        const delPM = await this.$showAlert(
          'warning',
          'PM Delete',
          `Are you sure you want to delete ${this.selectedPM.length} PM(s)?`,
          [{ text: 'Delete' }, { text: 'Cancel' }],
        );

        if (delPM === 'Delete') {
          this.$bus.$emit('pmDeleted', this.selectedPM);
        }
      }
    },
    pmAdded: async function (pm) {
      let action = 'N';
      // find duplicate PM
      const duplicatePMIndex = this.popupContent.tabsData[5].data.vehicleItems.findIndex(
        (i) => i.Lorry_No.trim().toUpperCase() === pm['Lorry_No'].trim(),
      );
      if (duplicatePMIndex !== -1) {
        const replaceResponse = await this.$showAlert(
          'warning',
          'Duplicate PM',
          `The PM No. ${pm['Lorry_No'].trim()} already exists. \nDo you want to replace it instead?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'lightgray' },
          ],
        );
        if (replaceResponse === 'No') {
          return;
        }
        // remove the duplicate item from the list before adding the edited item
        this.popupContent.tabsData[5].data.vehicleItems.splice(duplicatePMIndex, 1);
        action = 'E'; // action change to 'E' due to replace
      }

      // Check if the PM was deleted
      // If found in the deletedVehicle array, remove it (since the user added it back)
      const deletedCheck = this.popupContent.popupData.deletedVehicle.findIndex(
        (i) => i['Lorry_No'].trim().toUpperCase() === pm['Lorry_No'].trim(),
      );
      if (deletedCheck !== -1) {
        this.popupContent.popupData.deletedVehicle.splice(deletedCheck, 1);
        action = 'E';
      }

      const temp = this.popupContent.tabsData[5].data.vehicleItems;
      this.popupContent.tabsData[5].data.vehicleItems = [];
      temp.push({
        vehicleaction: action,
        Lorry_No: pm['Lorry_No'],
        VehicleCode: pm['Lorry_No'],
        Type: pm['Type'] || '',
      });
      this.$nextTick(() => {
        this.popupContent.tabsData[5].data.vehicleItems = temp;
      });

      this.pmNo = '';
      this.selectedMvt = null;
    },
    pmDeleted: function (pms) {
      pms.forEach((p) => {
        const temp = this.popupContent.tabsData[5].data.vehicleItems;
        const delIndex = this.popupContent.tabsData[5].data.vehicleItems.findIndex((i) => i.Lorry_No === p.Lorry_No);
        this.popupContent.tabsData[5].data.vehicleItems = [];
        temp.splice(delIndex, 1);

        this.$nextTick(() => {
          this.popupContent.tabsData[5].data.vehicleItems = temp;
        });

        if (!p.vehicleaction) {
          this.popupContent.popupData.deletedVehicle.push(p);
        }
      });
    },
    // Populating Tabs
    // requiredClicked: function(errorItem) {
    //   this.popupContent.popupData.focusElement = errorItem;
    // },
    resizeTabHeight: function () {
      try {
        const code = this.$refs['code-section'].getBoundingClientRect();
        const checkbox = this.$refs['checkbox-section'].getBoundingClientRect();

        this.$refs['tab'].$el.style.height = `calc(100% - ${code.height + checkbox.height + 10}px)`;
      } catch (error) {
        throw new Error('Resize error!');
      }
    },
    checkFields: function () {
      this.clearMessages();
      if (this.popupContent.popupData.Spp_Code.trim() === '') {
        this.popupContent.popupData.SppCodeError = 'Supplier Code is required!';
        this.entryRequired.push({
          key: 'popupContent.popupData.SppCodeError',
          value: 'Supplier Code is required!',
        });
      } else if (this.popupContent.popupData.Spp_Code.length > 10) {
        this.popupContent.popupData.SppCodeError = 'Supplier Code cannot exceed 10 characters';
        this.entryRequired.push({
          key: 'popupContent.popupData.SppCodeError',
          value: 'Supplier Code cannot exceed 10 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.name.trim() === '') {
        this.popupContent.tabsData[0].data.nameError = 'Supplier Name is required!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.nameError',
          value: 'Supplier Name is required!',
        });
      } else if (this.popupContent.tabsData[0].data.name.length > 100) {
        this.popupContent.tabsData[0].data.nameError = 'Supplier Name cannot exceed 100 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.nameError',
          value: 'Supplier Name cannot exceed 100 characters!,',
        });
      }

      if (this.popupContent.tabsData[0].data.shortName.trim() === '') {
        this.popupContent.tabsData[0].data.shortNameError = 'Supplier short name is required!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.shortNameError',
          value: 'Supplier short name is required!',
        });
      } else if (this.popupContent.tabsData[0].data.shortName.length > 20) {
        this.popupContent.tabsData[0].data.shortNameError = 'Supplier short name cannot exceed 20 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.shortNameError',
          value: 'Supplier short name cannot exceed 20 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.addressLine1.length > 40) {
        this.popupContent.tabsData[0].addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
        this.entryRequied.push({
          key: 'popupContent.tabsData[0].data.addressErrors.addressLine1',
          value: 'Address Line 1 cannot exceed 40 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.addressLine2.length > 40) {
        this.popupContent.tabsData[0].addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        this.entryRequied.push({
          key: 'popupContent.tabsData[0].data.addressErrors.addressLine2',
          value: 'Address Line 2 cannot exceed 40 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.addressLine3.length > 40) {
        this.popupContent.tabsData[0].addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        this.entryRequied.push({
          key: 'popupContent.tabsData[0].data.addressErrors.addressLine3',
          value: 'Address Line 3 cannot exceed 40 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.addressLine4.length > 40) {
        this.popupContent.tabsData[0].addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        this.entryRequied.push({
          key: 'popupContent.tabsData[0].data.addressErrors.addressLine4',
          value: 'Address Line 4 cannot exceed 40 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.city.length > 30) {
        this.popupContent.tabsData[0].data.addressErrors.city = 'City cannot exceed 30 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].addressErrors.city',
          value: 'City cannot exceed 30 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.postcode.length > 10) {
        this.popupContent.tabsData[0].data.addressErrors.postcode = 'Postcode cannot exceed 10 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].addressErrors.postcode',
          value: 'Postcode cannot exceed 10 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.address.state.length > 30) {
        this.popupContent.tabsData[0].data.addressErrors.state = 'State cannot exceed 30 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].addressErrors.state',
          value: 'State cannot exceed 30 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.phone.length > 20) {
        this.popupContent.tabsData[0].data.phoneError = 'Phone No. cannot exceed 20 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.phoneError',
          value: 'Phone No. cannot exceed 20 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.fax.length > 20) {
        this.popupContent.tabsData[0].data.faxError = 'Fax No. cannot exceed 20 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.faxError',
          value: 'Fax No. cannot exceed 20 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.email.length > 40) {
        this.popupContent.tabsData[0].data.emailError = 'Email cannot exceed 40 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[0].data.emailError',
          value: 'Email cannot exceed 40 characters!',
        });
      }

      if (this.popupContent.tabsData[0].data.categoryText.length > 10) {
        this.popupContent.tabsData[0].data.categoryError = 'Category cannot exceed 10 characters!';
        this.entryRequired.push({
          key: 'this.popupContent.tabsData[0].data.categoryError',
          value: 'Category cannot exceed 10 characters!',
        });
      }

      if (this.popupContent.tabsData[1].data.contactPerson.length > 100) {
        this.popupContent.tabsData[1].data.contactPersonError = 'Contact person cannot exceed 100 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[1].data.contactPersonError',
          value: 'Contact Person cannot exceed 100 characters!',
        });
      }

      if (this.popupContent.tabsData[3].data.comRegNo.length > 25) {
        this.popupContent.tabsData[3].data.comRegNoError = 'Com Reg No. cannot exceed 25 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[3].data.comRegNoError',
          value: 'Com Reg No. cannot exceed 25 characters!',
        });
      }

      if (
        this.popupContent.tabsData[3].data.dateVerified &&
        this.popupContent.tabsData[3].data.dateVerified < new Date('1990-01-01')
      ) {
        this.popupContent.tabsData[3].data.dateVerifiedError = 'Invalid Date!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[3].data.dateVerifiedError',
          value: 'Invalid Date!',
        });
      }

      if (this.popupContent.tabsData[3].data.licenseNo.length > 50) {
        this.popupContent.tabsData[3].data.licenseNoError = 'License No. cannot exceed 50 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[3].data.licenseNoError',
          value: 'License No. cannot exceed 50 characters!',
        });
      }

      if (this.popupContent.tabsData[3].data.rmcdApprovalNo.length > 25) {
        this.popupContent.tabsData[3].data.rmcdApprovalNoError = 'RMCD Approval No. cannot exceed 25 characters!';
        this.entryRequired.push({
          key: 'popupContent.tabsData[3].data.rmcdApprovalNoError',
          value: 'RMCD Approval No. cannot exceed 25 characters!',
        });
      }

      if (this.tabsItems[4].disabled == false) {
        // agentCode is a PK for its table and should have the same value as Supplier's Code
        // Since Agent Code's field has been disabled, below is for reference for its validation
        // if (this.popupContent.tabsData[4].data.agentCode === '') {
        //   this.popupContent.tabsData[4].data.agentCodeError = 'Agent Code is required!';
        //   this.entryRequired.push({
        //     key: 'popupContent.tabsData[4].data.agentCodeError',
        //     value: 'Agent Code is required!',
        //   });
        // } else if (this.popupContent.tabsData[4].data.agentCode.length > 10) {
        //   this.popupContent.tabsData[4].data.agentCodeError = 'Agent Code cannot exceed 10 characters!';
        //   this.entryRequired.push({
        //     key: 'popupContent.tabsData[4].data.agentCodeError',
        //     value: 'Agent Code cannot exceed 10 characters!',
        //   });
        // }

        if (this.popupContent.tabsData[4].data.effectiveDateStart) {
          if (this.popupContent.tabsData[4].data.effectiveDateEnd === '') {
            this.popupContent.tabsData[4].data.effectiveDateEndError = 'Date End is empty!';
            this.entryRequired.push({
              key: 'popupContent.tabsData[4].data.effectiveDateEndError',
              value: 'Date End is empty!',
            });
          } else if (
            this.popupContent.tabsData[4].data.effectiveDateStart > this.popupContent.tabsData[4].data.effectiveDateEnd
          ) {
            this.popupContent.tabsData[4].data.effectiveDateStartError = 'Date Start cannot be later than Date End!';
            this.entryRequired.push({
              key: 'popupContent.tabsData[4].data.effectiveDateStartError',
              value: 'Date Start cannot be later than Date End!',
            });
          } else if (
            new Date(this.popupContent.tabsData[4].data.effectiveDateStart).formatString('dd/MM/yyyy HH:mm') ===
            new Date(this.popupContent.tabsData[4].data.effectiveDateEnd).formatString('dd/MM/yyyy HH:mm')
          ) {
            this.popupContent.tabsData[4].data.effectiveDateStartError = 'Date Start cannot be the same as Date End!';
            this.entryRequired.push({
              key: 'popupContent.tabsData[4].data.effectiveDateStartError',
              value: 'Date Start cannot be the same as Date End!',
            });
          } else if (this.popupContent.tabsData[4].data.effectiveDateStart < new Date('1990-01-01')) {
            if (this.popupContent.tabsData[4].data.effectiveDateEnd < new Date('1990-01-01')) {
              this.popupContent.tabsData[4].data.effectiveDateEndError = 'Invalid Until Date!';
              this.entryRequired.push({
                key: 'popupContent.tabsData[4].data.effectiveDateEndError',
                value: 'Invalid Until Date!',
              });
            }
            this.popupContent.tabsData[4].data.effectiveDateStartError = 'Invalid Effective Date From!';
            this.entryRequired.push({
              key: 'popupContent.tabsData[4].data.effectiveDateStartError',
              value: 'Invalid Effective Date From!',
            });
          }
        }

        if (
          this.popupContent.tabsData[4].data.effectiveDateEnd !== '' &&
          this.popupContent.tabsData[4].data.effectiveDateStart === ''
        ) {
          this.popupContent.tabsData[4].data.effectiveDateStartError = 'Date Start is empty!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[4].data.effectiveDateStartError',
            value: 'Date Start is empty!',
          });
        }

        if (this.popupContent.tabsData[4].data.demurageDays === '') {
          this.popupContent.tabsData[4].data.demurageDaysError = 'Demurrage Days is required!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[4].data.demurageDaysError',
            value: 'Demurrage Days is required!',
          });
        } else if (this.popupContent.tabsData[4].data.demurageDays > 255) {
          this.popupContent.tabsData[4].data.demurageDaysError = 'Demurrage Days cannot exceed 255 days!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[4].data.demurageDaysError',
            value: 'Demurrage Days cannot exceed 255 days!',
          });
        }

        if (this.popupContent.tabsData[4].data.detentionDays === '') {
          this.popupContent.tabsData[4].data.detentionDaysError = 'Detention Days is required!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[4].data.detentionDaysError',
            value: 'Detention Days is required!',
          });
        } else if (this.popupContent.tabsData[4].data.detentionDays > 255) {
          this.popupContent.tabsData[4].data.detentionDaysError = 'Detention Days cannot exceed 255 days!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[4].data.detentionDaysError',
            value: 'Detention Days cannot exceed 255 days!',
          });
        }

        if (this.popupContent.tabsData[4].data.oprCode.length > 10) {
          this.popupContent.tabsData[4].data.oprCodeError = 'Opr Code cannot exceed 10 characters!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[4].data.oprCodeError',
            value: 'Opr Code cannot exceed 10 characters!',
          });
        }
      }

      if (this.tabsItems[5].disabled == false) {
        // Haulier Code is a PK for its table and should have the same value as Supplier's Code
        // Since Haulier Code's field has been disabled, below is for reference for its validation
        // if (this.popupContent.tabsData[5].data.haulierCode.trim() === '') {
        //   this.popupContent.tabsData[5].data.haulierCodeError = 'Haulier Code is required!';
        //   this.entryRequired.push({
        //     key: 'popupContent.tabsData[5].data.haulierCodeError',
        //     value: 'Haulier Code is required!',
        //   });
        // } else if (this.popupContent.tabsData[5].data.haulierCode.length > 10) {
        //   this.popupContent.tabsData[5].data.haulierCodeError = 'Haulier Code cannot exceed 10 characters!';
        //   this.entryRequired.push({
        //     key: 'popupContent.tabsData[5].data.haulierCodeError',
        //     value: 'Haulier Code cannot exceed 10 characters!',
        //   });
        // }

        if (this.popupContent.tabsData[5].data.cmrForm === '') {
          this.popupContent.tabsData[5].data.cmrFormError = 'CMR Form is required!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[5].data.cmrFormError',
            value: 'CMR Form is required!',
          });
        } else if (this.popupContent.tabsData[5].data.cmrForm.length > 10) {
          this.popupContent.tabsData[5].data.cmrFormError = 'CMR Form cannot exceed 10 characters!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[5].data.cmrFormError',
            value: 'CMR Form cannot exceed 5 characters!',
          });
        }

        if (this.popupContent.tabsData[5].data.selectedMode == null) {
          this.popupContent.tabsData[5].data.modeError = 'Mode is required!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[5].data.modeError',
            value: 'Mode is required!',
          });
        }

        if (this.popupContent.tabsData[5].data.pkNetID.length > 10) {
          this.popupContent.tabsData[5].data.pkNetIDError = 'PKNet ID cannot exceed 10 characters!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[5].data.pkNetIDError',
            value: 'PKNet ID cannot exceed 10 characters!',
          });
        }

        if (
          this.popupContent.tabsData[5].data.dateVerified &&
          this.popupContent.tabsData[5].data.dateVerified < new Date('1990-01-01')
        ) {
          this.popupContent.tabsData[5].data.dateVerifiedError = 'Invalid Date Verified!';
          this.entryRequired.push({
            key: 'popupContent.tabsData[5].data.dateVerified',
            value: 'Invalid Date Verified!',
          });
        }
      }

      return this.entryRequired.length > 0;
    },
    tabClicked: async function (_tabItem, tabIndex) {
      if (this.showContactDetailsInput && tabIndex !== 1) {
        const discardChanges = await this.promptDiscardContactDetailsChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showContactDetailsInput = false;
      }
      this.currentTab = tabIndex;
    },
    promptDiscardContactDetailsChanges: function () {
      return this.$showAlert(
        'warning',
        'Discard Changes',
        'You have unsaved Contact Details changes.<br>Do you wish to discard the changes?',
        [{ text: 'Discard', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );
    },
    validateTaxPayerTin: async function () {
      if (
        !this.eInvoiceTIN.startsWith('EI') &&
        (!this.popupContent.tabsData[3].data.comRegNo || this.popupContent.tabsData[3].data.comRegNo == '')
      ) {
        this.$showAlert('error', 'Missing ID Number', 'Please key in New Comp Reg No');
        return;
      }

      this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/LoadingCircle.gif';
      this.validateTINMsg = 'Validating';

      const jsonBody = {
        tin: this.eInvoiceTIN,
        brn: this.popupContent.tabsData[3].data.comRegNo,
      };
      const result = await this.$apiCallV2('/ARInvoice/ValidateTaxpayerTin', jsonBody);
      if (result?.[0]?.['Results'] == 0) {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Save.png';
        this.validateTINMsg = 'Valid Taxpayer TIN';
      } else {
        this.validateTINIcon = 'https://dsmlib.logistics.systems/Icons/Cancel.png';
        this.validateTINMsg = `Invalid Taxpayer TIN (${result?.[0]?.['ErrMsg']})`;
      }
    },
  },
  async mounted() {
    await this.sasControlFunction();
    this.clearData();
    this.$fullscreenLoading('Getting Suppliers');

    const suppliers = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'supplier' });
    this.supplierData = suppliers;

    this.$fullscreenLoading('Getting Postcodes');
    const postcode = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'postcode' });
    this.popupContent.tabsData[0].data.postcodeItems = postcode;
    // this.popupContent.tabsData[1].data.postcodeItems = postcode;
    this.postcodeData = postcode;

    this.$fullscreenLoading('Getting States');
    const states = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'state' });
    states.forEach((s) => {
      s.State = s.State.trim();
    });
    this.popupContent.tabsData[0].data.stateItems = states;
    // this.popupContent.tabsData[1].data.stateItems = states;
    this.stateData = states;

    this.$fullscreenLoading('Getting Country');
    const countries = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' });
    countries.forEach((c) => {
      c.Country = c.Country.trim();
    });
    this.popupContent.tabsData[0].data.countryItems = countries;
    // this.popupContent.tabsData[1].data.countryItems = countries;
    this.countryData = countries;

    this.$fullscreenLoading('Getting Category');
    const categories = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'supplier_category' });
    categories.forEach((c) => {
      c['Supplier Category'] = c['Supplier Category'].trim();
    });
    this.popupContent.tabsData[0].data.categoryItems = categories;
    this.categoryData = categories;

    this.$fullscreenLoading('Getting Tax Codes');
    const taxCodes = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'aptaxcode' });
    taxCodes.forEach((t) => {
      t['Tax Code'] = t['Tax Code'] ? t['Tax Code'].trim() : '';
      t['Tax Code Desc'] = t['Tax Code Desc'] ? t['Tax Code Desc'].trim() : '';
      t['Tax Type'] = t['Tax Type'] ? t['Tax Type'].trim() : '';
    });
    this.popupContent.tabsData[3].data.taxCodeItems = taxCodes.map((item) => {
      return {
        ...item,
        'Tax Code - Tax Code Desc': `${item['Tax Code']} - ${item['Tax Code Desc']}`,
      };
    });

    this.$fullscreenLoading('Getting MSIC Codes');
    const msicCodes = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'MSIC' });
    this.popupContent.tabsData[3].data.msicCodeItems = msicCodes;

    this.$fullscreenLoading('Getting Customers');
    const billCust = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'billcust' });
    billCust.forEach((b) => {
      b['Customer Code'] = b['Customer Code'] ? b['Customer Code'].trim() : '';
      b['Customer Name'] = b['Customer Name'] ? b['Customer Name'].trim() : '';
    });
    this.popupContent.tabsData[4].data.billToItems = billCust;
    this.popupContent.tabsData[5].data.billToItems = billCust;

    this.$fullscreenLoading('Getting Haulier Mode');
    const haulierMode = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'haulier_mode' });
    this.popupContent.tabsData[5].data.modeItems = haulierMode;

    this.$fullscreenLoading('Getting Haulier Movement');
    const haulierMvt = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'haulier_mvt' });
    this.popupContent.tabsData[5].data.mvtItems = haulierMvt;

    this.$fullscreenLoading('Getting Creditors');
    const creditorList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'creditor' });
    this.popupContent.tabsData[0].data.creditor = creditorList;
    this.popupContent.tabsData[0].data.creditor.forEach((c) => {
      c['Creditor Code'] = c['Creditor Code'].trim();
    });

    // POST listeners (Attachment has none)
    this.$bus.$on('contactDeleted', this.contactDeleted);
    this.$bus.$on('attachmentsDeleted', this.attachmentsDeleted);
    this.$bus.$on('oprCodeAdded', this.oprCodeAdded);
    this.$bus.$on('oprCodeDeleted', this.oprCodeDeleted);
    this.$bus.$on('pmAdded', this.pmAdded);
    this.$bus.$on('pmDeleted', this.pmDeleted);

    // Agent mounts
    // this.$bus.$on('supplierAgentFocusElement', (element) => {
    //   this.$refs[element].setFocus();
    // });

    this.$fullscreenLoading();

    window.addEventListener('resize', this.resizeTabHeight);

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Supplier' });
      if (this.$route.query['supplier']) {
        switch (this.$route.query['supplier']) {
          case 'FA':
            this.popupContent.popupData.IsFwdAgt = true;
            break;
          case 'SA':
            this.popupContent.popupData.IsShipAgt = true;
            break;
          case 'SL':
            this.popupContent.popupData.IsShipLine = true;
            break;
          case 'A':
            this.popupContent.popupData.IsAirLine = true;
            break;
          case 'CA':
            this.popupContent.popupData.IsCarrierAgt = true;
            break;
          case 'EMA':
            this.popupContent.popupData.IsEastMsiaAgt = true;
            break;
          case 'OA':
            this.popupContent.popupData.IsOverseasAgt = true;
            break;
          case 'H':
            this.popupContent.popupData.IsHaulier = true;
            break;
        }
      }
    }
  },
  computed: {
    isCompulsory: {
      get() {
        return this.popupContent.tabsData[4].data.compulsoryCustRef == 1;
      },
      set(value) {
        this.popupContent.tabsData[4].data.compulsoryCustRef = value ? 1 : 0;
      },
    },
  },
  watch: {
    showPopup: function (val) {
      if (!val) {
        this.clearData();
        this.clearMessages();
      }
    },

    currentTab: function (val) {
      if (val == 4) {
        this.selectedContOpr = []; // Clear selected operator when switch to Agent tab
      }
    },

    // Contact
    contactPerson: function (val) {
      this.$emit('update:person', val);
    },

    // Main watch
    popupContent: {
      deep: true,
      handler: function (val) {
        val = val.popupData;
        const agentCheckboxes =
          val.IsFwdAgt ||
          val.IsShipAgt ||
          val.IsShipLine ||
          val.IsAirLine ||
          val.IsCarrierAgt ||
          val.IsEastMsiaAgt ||
          val.IsOverseasAgt;
        const haulierCheckBox = val.IsHaulier;

        //to default the agent or haulier code to be same as supplier code if change from uncheck to check only
        if (this.tabsItems[4].disabled == false && agentCheckboxes == true) {
          this.popupContent.tabsData[4].data.agentCode = this.popupContent.popupData.Spp_Code;
        }
        if (this.tabsItems[5].disabled == false && haulierCheckBox == true) {
          this.popupContent.tabsData[5].data.haulierCode = this.popupContent.popupData.Spp_Code;
        }

        this.tabsItems[4].disabled = agentCheckboxes == false;
        this.tabsItems[5].disabled = haulierCheckBox == false;
        // Forces out of tab if current tab is disabled
        if (this.tabsItems[this.currentTab].disabled == true) {
          this.currentTab = 3;
        }
      },
    },

    popupEntryShow: async function (val) {
      if (val) {
        this.$nextTick(() => {
          this.resizeTabHeight();
        });
      }

      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        const closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Supplier Creation',
          `You have not created an Supplier profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },
    eInvoiceTIN: function () {
      this.validateTINIcon = '';
    },
    'popupContent.tabsData.3.data.comRegNo': function () {
      this.validateTINIcon = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.supplier-main {
  width: 100%;
  height: 100%;
  display: flex;
  // background-color: yellow;
  padding: 10px 45px;
  font-size: 12px;
}

.right-container {
  width: 100%;
  overflow: hidden;
  height: 100%;
  padding: 5px;
  border-radius: 5px;
  margin-left: 5px;
  background-color: white;
}

.rowBox {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: 0.3s;
}

// CHECKBOX
.code-section {
  display: flex;
}

.checkbox-section {
  display: flex;
  width: 100%;
  margin-bottom: 10px;

  > * {
    flex-grow: 1;
    margin-right: 5px;
  }
}

// AGENT
.effective-date-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  > div {
    margin-right: 15px;
  }
}

.add-del-opr-container {
  display: flex;
}

.compulsory-checkbox {
  width: fit-content;
  margin-bottom: 10px;
}

// HAULIER
.supplier-haulier-main {
  display: flex;
}

.flex-area {
  display: flex;
  align-items: center;
}

.right-container {
  overflow: hidden;
  display: flex;
  padding-top: 10px;

  > .pm-tabulator {
    width: calc(100% - 105px);
    height: fit-content;
  }

  > .add-pm-area {
    width: 200px;
    margin-left: 5px;
  }
}

.lhdn-tin {
  display: flex;
  flex-direction: row;
}
</style>
